import { Button, Typography } from '@finam/web-ui-kit';
import { DocArrowDown } from '@finam/web-ui-kit/Icons/Doc';
import { Icon } from '@finam/web-ui-kit/Input/Input.styles';
import React, { ReactElement } from 'react';
import { WebService } from '../../Services/WebService';
import { TokenContext } from '../../TokenContext';
import './Fields.scss';
import { FileItem } from './FileItem';
import cn from 'classnames'

interface IFileItem {
    name: string;
    id: number;
    isNew: boolean;
}

interface IFieldProps {
    files: IFileItem[];
    label?: string;
    description?: string;
    info?: string;
    onChange: (value: FileList | null) => void;
    acceptExtensions?: string;
    nnDoc: number,
    isRequired: boolean,
}



export default class FileField extends React.Component<IFieldProps, {}>{
    private fileInput: React.RefObject<HTMLInputElement>;
    static contextType?= TokenContext;
    context!: React.ContextType<typeof TokenContext>;

    constructor(props: IFieldProps) {
        super(props);
        this.fileInput = React.createRef();
    }


    private DownloadFile(fileId: number): void {
        new WebService(this.context.token).DownloadDocument(this.props.nnDoc, fileId).then(res => {
            var a = document.createElement("a"); //Create <a>
            a.href = res.fileData; //Image Base64 Goes here
            a.download = res.fileName; //File name Here
            a.click(); //Downloaded file
        });
    }

    private FileItem(file: IFileItem, key: string) {
        return <div key={key} className={cn('file-field__fileItem', { 'new': file.isNew })}>
            <div onClick={() => { if (!file.isNew) this.DownloadFile(file.id) }}>{file.name}</div>
            { !file.isNew && <div className='new-label'>Уже загружен</div> }
        </div>
    }

    render() {
        return <div className='file-field'>
            <div className='file-field__header'>
                {this.props.label &&
                    <div className='field-label'>
                        <Typography variant='body16' weight='semiBold'><span className={cn({ 'required': this.props.isRequired })}>{this.props.label}</span><span className='field-description'>{this.props.description}</span></Typography>
                    </div>}
                <div className='field-downloadLabel' onClick={() => this.fileInput.current?.click()}>
                    <img src={process.env.PUBLIC_URL + 'icons/Attach_1.svg'} /><span>Прикрепите файл</span>
                </div>
                {this.props.info && <div className='infoIcon'><img src={process.env.PUBLIC_URL + 'icons/Info.svg'} /></div>}
            </div>
            {
                <div className='field-body'>
                    <input ref={this.fileInput}
                        multiple={true}
                        type="file"
                        style={{ display: 'none' }}
                        accept={this.props.acceptExtensions}
                        onChange={(event) => this.props.onChange(event.target.files)}
                    />
                    {this.props.files.map((f, i) => this.FileItem(f, `file_${i}`))}
                </div>
            }
        </div>
    }
} 